import { createContext } from 'react';

import { PageError } from '@xing-com/crate-entity-pages-entity-pages-shared-components-page-error';
import type { HeaderModule } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { useEntityPageModules } from '../../hooks/use-entity-page-modules/use-entity-page-modules';
import type { PageModule } from '../../types/page-modules';

export type ModulesContextType = {
  industryId?: string;
  hasNewsModule: boolean;
  pageModulesByType: string[];
  headerModule?: HeaderModule;
  pageModules: PageModule[];
};
export const ModulesContext = createContext<ModulesContextType | null>(null);

export const ModulesContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { data, error } = useEntityPageModules();

  if (error) {
    return <PageError />;
  }

  return (
    <ModulesContext.Provider value={data}>{children}</ModulesContext.Provider>
  );
};
